export default "__VITE_ASSET__CvqXVs9v__"